import { Link } from 'react-router-dom';
import { StatusBadge } from '@/components/common/StatusBadge';
import type { UpcomingJob } from '@/lib/api/dashboard';
import { jobPath } from '@/lib/utils/navPaths';

const humanize = (s: string) =>
  s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const fmtDate = (d: string | null) => {
  if (!d) return 'No date set';
  const date = new Date(d.slice(0, 10) + 'T00:00:00');
  if (isNaN(date.getTime())) return 'No date set';
  return date.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const JobListItem = ({ job }: { job: UpcomingJob }) => {
  return (
    <Link
      to={jobPath(undefined, job.id)}
      className="flex items-center gap-4 p-4 border-b border-gray-100 last:border-b-0 hover:bg-primary/5 transition-colors"
    >
      <div className="min-w-0 flex-grow">
        <p className="truncate font-bold text-gray-900">{job.title}</p>
        <p className="truncate text-sm text-gray-600">
          {job.client}{job.crew ? ` · ${job.crew}` : ''}
        </p>
      </div>
      <div className="shrink-0 text-right">
        <p className="text-sm font-medium text-gray-900">{fmtDate(job.date)}</p>
        <StatusBadge status={humanize(job.status)} className="mt-1" />
      </div>
    </Link>
  );
};
